import { connect } from 'react-redux';
import { AppDispatch, RootState } from 'src/store/store';
import Unload from 'src/components/pages/unload-page/Unload';
import { enterUnloadRoute, leaveUnloadRoute, UnloadRoute } from 'src/store/common-slices/unloadSlice';

const mapStateToProps = (state: RootState) => ({
    pageToRender: state.Unload.pageToRender,
    callPending: state.Unload.pending
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    enterUnloadRoute: (route: UnloadRoute) => dispatch(enterUnloadRoute(route)),
    leaveUnloadRoute: () => dispatch(leaveUnloadRoute())
});

export default connect(mapStateToProps, mapDispatchToProps)(Unload);
